import { ActionButton, IconButton, Stack, TooltipHost } from "@fluentui/react";
import * as React from "react";

export interface ClearButtonProps {
    disabled?: boolean;
    checked?: boolean;
    isLabeled?: boolean;
    onClear(): void;
}

export const ClearFiltersButton: React.FunctionComponent<ClearButtonProps> = (props: ClearButtonProps) => {
    const clear = () => props.onClear();

    return (
        <Stack horizontal={true}>
            {props.isLabeled ? (
                <ActionButton
                    iconProps={{ iconName: "ClearFilter" }}
                    allowDisabledFocus={true}
                    disabled={props.disabled}
                    checked={props.checked}
                    ariaLabel="Clear filters"
                    label="Clear filters"
                    onClick={clear}
                    data-testid="clear-filters-button"
                >
                    Clear filters
                </ActionButton>
            ) : (
                <TooltipHost content="Clear filters" styles={{ root: { display: "inline-block" } }}>
                    <IconButton
                        iconProps={{ iconName: "ClearFilter" }}
                        disabled={props.disabled}
                        checked={props.checked}
                        onClick={clear}
                    />
                </TooltipHost>
            )}
        </Stack>
    );
};
